import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { Typography } from "@material-ui/core";

import { FormattedMessage } from "react-intl";

export const PrintErrorModal: FC<{
  error?: Error;
  onClose: () => void;
  onRetry: () => void | Promise<void>;
  onUseLaser: () => void | Promise<void>;
}> = ({ error, onClose, onRetry, onUseLaser }) => (
  <DialogContainer open onClose={onClose}>
    <DialogHeader title="">
      <Typography variant="h5" component="h2" style={{ fontWeight: "bold" }}>
        Error
      </Typography>
      <Typography variant="subtitle2">
        <FormattedMessage
          id="invoice.printModal.error.subtitle"
          defaultMessage="There was an error communicating to the thermal printer"
        />
      </Typography>
    </DialogHeader>
    <DialogBody>
      <Typography variant="body2">
        <FormattedMessage
          id="invoice.printModal.error.message"
          defaultMessage="Please try again, or try laser printing instead."
        />
      </Typography>
      <Typography variant="body2">
        <em>{error.toString()}</em>
      </Typography>
    </DialogBody>
    <DialogFooter>
      <Button color="secondary" onClick={onClose}>
        <FormattedMessage
          id="invoice.printModal.error.actions.cancel"
          defaultMessage="Cancel"
        />
      </Button>
      <Button color="secondary" onClick={onUseLaser}>
        <FormattedMessage
          id="invoice.printModal.error.actions.laser"
          defaultMessage="Use Laser Printer"
        />
      </Button>
      <Button color="primary" onClick={onRetry}>
        <FormattedMessage
          id="invoice.printModal.error.actions.retry"
          defaultMessage="Try Again"
        />
      </Button>
    </DialogFooter>
  </DialogContainer>
);
